export default {
  // 清算单
  settlementBillList: '清算单列表',
  weeklyDocument: '周结账单',
  monthlyDocument: '月结账单',
  week: '周次',
  Monthly: '月度',
  period: '账单周期',
  salesRegion: '国别',
  storeMode: '经营性质',
  settlementDate: '出账日',
  details: '详情',
  actuallyPaid: '用户实付',
  commissionStandard: '计佣基数',
  commissionType: '计佣维度',
  platformLogisticsCharge: '平台揽收运费',
  coins: '应结算Coins',
  platformVoucher: '平台券结算额',
  storeVoucher: '店铺券',
  paymentCharge: '支付手续费',
  tradeCharge: '交易费',
  commission: '佣金',
  operationCharge: '操作费',
  refundInAftersales: '售后扣除',
  punishments: '奖惩',
  logisticsCharge: '物流费',
  settlementResult: '应结算金额',
  settlementBillDocument: '清算单详情',
  settlementBillNo: '清算单号',
  category: '品类',
  commissionRate: '品类佣金率',
  storeRate: '店铺佣金率',
  viewTheSettings: '详见品类佣金率设置',
  storeConfirmStatus: '店铺确认状态',
  platformConfirmStatus: '平台确认状态',
  summaryInformationOfTheDocument: '商城交易摘要信息',
  postageUserPaid: '交易运费总额',
  actuallyUserPaidTotal: '用户实付总额',
  coinsRedeem: 'Coins抵扣总额',
  voucherRedeemPlatform: '平台券抵扣总额',
  voucherRedeemStore: '店铺券抵扣总额',
  platformDeductionSummary: '商城交易应扣减费项',
  platformPayForCoins: '应结算Coins费用',
  platformPayForVoucherPlatform: '平台券应结算费用',
  correctionAmount: '修正补偿',
  aftersalesSummary: '售后费用',
  aftersalesCharge: '售后服务费',
  settlementResults: '清算结果',
  toBeSettledAmount: '应向卖家结算金额为',
  refundInAftersalesData: '售后扣款数据',
  aftersalesInformationInThisPeriod: '当期产生售后相关数据',
  refund: '退款',
  records: '笔',
  exportRefundDetails: '导出售后退款明细',
  correctionInfo: '数据修正补偿',
  addtionalDescr: '附加说明',
  attached: '附件',
  salesOrdersIncluded: '所纳入清算的订单明细',
  orderID: '订单编号',
  platform: '平台',
  storeNumber: '店铺ID',
  store: '店铺',
  itemTotal: '商品总额',
  userPaid: '用户支付',
  postageSettledTo: '运费结算对象',
  postage: '运费',
  postageDiscount: '运费折扣',
  voucherPlatform: '平台券额',
  voucherStore: '店铺券额',
  itemDiscount: '商品折扣',
  logisticsType: '订单运输类型',
  deliveryType: '交付类型',
  paymentType: '支付类型',
  customerID: '用户ID',
  warehouseID: '仓库ID',
  orderTime: '创建时间',
  completeTime: '完成时间',
  storeType1: '自营',
  storeType2: '第三方',
  storeType3: 'Kili Shop',
  storeType4: '代运营',
  detailTip: '当前功能处于测试期， 数据尚未验证， 以财务结算数据为准',
  show: '展开',
  hide: '收起',
  thereAre: '当前共有',
  recordsNum: '条修正历史记录',
  systemThe: '系统于',
  automaticlly: '确认了帐单',
  commistionType: '佣金类型',
  operationLog: '账单操作日志',
  success: '提交成功',
  invoiceQuery: '质疑账单',
  sendConfirmationReceipt: '发送确认回执',
  invoiceGeneration: '账单生成',
  storeConfirmsInvoice: '店铺确认账单',
  platformFinanceConfirmedInvoice: '平台确认账单',
  systemAutomaticallyConfirmedInvoice: '系统自动确认账单',
  platformRevisesInvoice: '平台修正账单',
  storeQueries: '店铺质疑',
  platformSuspends: '平台挂起',
  pendingSellerConfirmation: '待卖家确认',
  systemConfirmed: '系统已确认',
  platformFinanceConfirmed: '平台已确认',
  sellerSuspended: '平台挂起',
  pendingPlatformConfirmation: '待平台确认',
  operate: '操作'
}
